interface OppCourierStatsItem {
  label: string;
  value: string;
  bg?: string;
  border?: string;
  textColor?: string;
  subColor?: string;
}

export function OppCourierStatsGrid({ stats }: { stats: OppCourierStatsItem[] }) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {stats.map((stat) => (
        <div key={stat.label} className={`rounded-xl ${stat.bg ?? 'bg-muted/40'} p-3 text-center shadow-sm`}>
          <p className={`text-xl font-bold ${stat.textColor}`}>{stat.value}</p>
          <p className={`text-caption ${stat.subColor}`}>{stat.label}</p>
        </div>
      ))}
    </div>
  );
}
